module.exports = __webpack_public_path__ + "static/img/diamondpruksa.66043aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/diamondpruksa.svg
// module id = YvnN
// module chunks = 1